import axios from 'axios';

async function autenticar(email: string, senha: string): Promise<any> {
  await axios
    .post(`${process.env.REACT_APP_PORTAL_API}/autenticacao/autenticar`, {
      username: email,
      password: senha,
    })
    .then((res) => {
      localStorage.setItem('tokenIES', res.headers.token);
      localStorage.setItem('refreshToken', res.headers.refresh_token)
      localStorage.setItem('tokenRefreshed', "false");
      localStorage.setItem('usuarioIES', JSON.stringify(res.data));
      localStorage.setItem('NPSemailIES', res.data.email);
      localStorage.setItem('NPSnomeIES', res.data.nome);

      return res.data;
    })
    .catch((err) => Promise.reject(err.response));
}

export default autenticar;
